<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">资讯</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="doge-card consult-card">
        <h2>资讯</h2>
        <p>用户可使用站内 USDT 买入 DOGE 生态零钱罐，零钱罐收益按后台配置执行。</p>
        <p>首次买入后犹豫期内支持转出；超过犹豫期后，收益按规则进入可用余额或自动复投。</p>
        <p>申请结束投资后进入等待期，开放转出窗口内可将零钱罐余额转回站内可用余额。</p>
        <p>动态奖励包含直推、M1-M9级差和平级奖，等级与比例以后端配置为准。</p>
        <button class="doge-btn full" @click="$router.push({name:'doge'})">进入零钱罐</button>
      </section>
    </main>
    <BottomNav/>
  </div>
</template>
<script>import BottomNav from '../../components/layout/BottomNav.vue';export default{name:'question',components:{BottomNav}}</script>
<style scoped>.consult-card{background:#fff;color:#211507}.consult-card h2{margin:0 0 16px;color:var(--doge-primary);font-size:22px}.consult-card p{line-height:1.9;color:#3a2a0f;margin:12px 0;background:#fff8e8;border:1px solid #eee2c7;border-radius:12px;padding:10px 12px}.doge-btn{margin-top:18px}</style>
